import { Placeholder } from "@/components/Placeholder";

const ASSET_BASE = `${process.env.PUBLIC_URL || ""}/assets`;

const CARDS = [
  {
    title: "Digital by default",
    body: "Replacing paper and spreadsheet processes with systems that scale.",
  },
  {
    title: "Built bilingually",
    body: "Arabic and English designed together, not translated afterwards.",
  },
  {
    title: "Compliant by design",
    body: "PDPL obligations built into the product, and Meyar to govern them.",
  },
];

export function Vision2040() {
  return (
    <section
      data-testid="vision-2040-section"
      className="bg-wafa-cream/60"
    >
      <div className="mx-auto max-w-7xl px-4 py-20 lg:px-6 lg:py-28">
        <div className="grid gap-12 lg:grid-cols-12 lg:gap-16">
          <div className="lg:col-span-7">
            <div className="text-xs font-semibold uppercase tracking-widest text-wafa-primary">
              National direction
            </div>
            <h2 className="mt-3 font-heading text-3xl font-semibold tracking-tight text-wafa-deep sm:text-4xl lg:text-5xl">
              Built for where Oman is going.
            </h2>
            <div className="mt-6 space-y-4 text-base leading-relaxed text-wafa-ink/85 lg:text-lg">
              <p>
                Oman Vision 2040 sets out a national shift towards a diversified, digitally enabled
                economy — and the organisations delivering it need software built to the country's
                own standards, in its own languages, under its own regulations.
              </p>
              <p>
                That is the company we built. Bilingual by default. Designed around the Personal
                Data Protection Law from the first sprint. Staffed to support you in your working
                week, not someone else's.
              </p>
            </div>
          </div>
          <div className="lg:col-span-5">
            <picture>
              <source type="image/webp" srcSet={`${ASSET_BASE}/vision-2040.webp`} />
              <img
                src={`${ASSET_BASE}/vision-2040.jpg`}
                alt="Oman Vision 2040 editorial illustration — the Oman Vision 2040 logo with the Arabic tagline نتقدم بثقة, HM Sultan Haitham bin Tariq in traditional khanjar dress on the right, a landscape with modern Omani architecture, wind turbines and solar panels in the middle, and the four Vision pillars (People and Society, Economy and Development, Governance and Institutional Performance, Sustainable Environment) across the base"
                width="1600"
                height="960"
                loading="lazy"
                decoding="async"
                data-testid="vision-2040-image"
                className="block aspect-[5/3] w-full rounded-lg object-cover"
              />
            </picture>
          </div>
        </div>

        <div className="mt-14 grid gap-5 md:grid-cols-3">
          {CARDS.map((c) => (
            <div
              key={c.title}
              data-testid={`vision-card-${c.title.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}
              className="rounded-lg border border-wafa-deep/10 bg-white p-6 transition-all duration-200 hover:-translate-y-1 hover:border-wafa-deep/25 hover:shadow-[0_18px_40px_-20px_rgba(14,79,58,0.2)]"
            >
              <div className="font-heading text-xl font-semibold text-wafa-deep">{c.title}</div>
              <p className="mt-3 text-sm leading-relaxed text-wafa-ink/75 lg:text-base">{c.body}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
